<div class="page">
  <form>
    <div class="filter-bar">
      <div class="filter-bar-first-row">
        <div class="rounded-input" style="width: 15em; margin-right: 15px">
          <mat-select [formField]="lomake.valittuTili">
            @for (tili of reskontraTilitObservable | async; track tili) {
              <mat-option [value]="tili.numero + ' ' + tili.nimi">{{ tili.numero + ' ' + tili.nimi }}</mat-option>
            }
          </mat-select>
        </div>

        <div class="rounded-input" style="margin-right: 15px">
          <input [matDatepicker]="dpAlku" [formField]="lomake.alkuPvm" placeholder="Alku" />
          <app-icon-button (click)="dpAlku.open()" actionId="Valitse kalenterista (reskontra alkuaika)" styles="width: 20px; height: 20px; line-height: 20px; padding: 0;">
            <mat-icon style="width: 20px; height: 20px; line-height: 20px; font-size: 16px; margin-top: 3px">calendar_today</mat-icon>
          </app-icon-button>
          <mat-datepicker #dpAlku startView="month"></mat-datepicker>
        </div>

        <div class="rounded-input">
          <input [matDatepicker]="dp" [formField]="lomake.pvm" />
          <app-icon-button (click)="dp.open()" actionId="Valitse kalenterista (reskontra aika)" styles="width: 20px; height: 20px; line-height: 20px; padding: 0;">
            <mat-icon style="width: 20px; height: 20px; line-height: 20px; font-size: 16px; margin-top: 3px">calendar_today</mat-icon>
          </app-icon-button>
          <mat-datepicker #dp startView="month"></mat-datepicker>
        </div>

        @if (naytaToimittajaValinta) {
          <div class="rounded-input" style="margin-left: 15px">
            <input #toimittajaInput type="text" [matAutocomplete]="toimittajaAuto" [formField]="lomake.toimittaja" matInput placeholder="Rajaa toimittajalla" data-lpignore="true" (focus)="onToimittajaFocus()" />
            @if (valittuToimittaja) {
              <i style="cursor: pointer; font-size: 20px" matSuffix class="icon ion-ios-close" (click)="poistaValittuToimittaja()"></i>
            }
          </div>
          <mat-autocomplete #toimittajaAuto="matAutocomplete" [displayWith]="toimittajaDisplayFn" [panelWidth]="350">
            @for (toimittaja of suodatetutToimittajat | async; track toimittaja) {
              <mat-option [value]="toimittaja"> {{ toimittaja.numero }} {{ toimittaja.nimi }} {{ toimittaja.ytunnus ? `(${toimittaja.ytunnus})` : '' }} </mat-option>
            }
          </mat-autocomplete>
        }
      </div>

      <div class="filter-bar-second-row">
        <mat-slide-toggle style="margin-right: 15px" aria-label="Näytä vain avoimet" [formField]="lomake.vainAvoimet">Näytä vain avoimet</mat-slide-toggle>

        <app-button (click)="downloadPdf()" actionId="Lataa pdf koneelle (reskontra)" [actionContext]="[lomake().value()]" styles="font-size: 11px; margin-top: -7px">
          <i class="fa fa-arrow-down"></i>
          <br />
          <div style="line-height: 2px; padding-bottom: 10px">PDF</div>
        </app-button>
        <app-button (click)="downloadCsv()" actionId="Lataa csv koneelle (reskontra)" [actionContext]="[lomake().value()]" styles="font-size: 11px; margin-top: -7px">
          <i class="fa fa-arrow-down"></i>
          <br />
          <div style="line-height: 2px; padding-bottom: 10px">Excel</div>
        </app-button>
      </div>
    </div>

    <div class="grid-parent" style="margin-bottom: 5px">
      <div style="text-align: right">Debet</div>
      <div></div>
      <div>Kredit</div>
    </div>

    <!-- <div *ngIf="selectedVientiSubject.value && selectedVientiSubject.value.a?.length" class="grid-parent resk-group">
    <div class="empty-outline" [style.visibility]="selectedVientiSubject.value?.d === 'd' ? 'visible' : 'hidden'"></div>
    <div></div>
    <div class="empty-outline" [style.visibility]=" selectedVientiSubject.value?.d==='k' ? 'visible' : 'hidden'"></div>
  </div> -->

    @for (group of renderableReskontraGroups; track group) {
      <div class="resk-group" [class.resk-group-border]="group.displayGroupBorder">
        <div class="grid-parent">
          <div>
            @for (leftCol of group.leftColumnViennit; track leftCol) {
              <div
                app-kirjanpito-reskontra-single-box
                (openKirjaus)="onOpenKirjaus($event)"
                [debugUrlStart]="debugUrlStart()"
                [maksutapa]="maksutavatMap().get(leftCol.mt)"
                [toimittaja]="kaikkiToimittajatMap().get(leftCol.ta)"
                (setBoxHeight)="(group.rightColumnViennit?.length)"
                [vienti]="leftCol"
                [isSelected]="selectedVientiSubject.value?.av === leftCol.av"
                (click)="vientiClicked(leftCol, group.order, $event)"
                [attr.data-vientiavain]="leftCol.av"
              ></div>
            }
            <!-- <div class="empty-outline" style="margin-top: 10px;" *ngIf="selectedVientiSubject.value && selectedVientiSubject.value?.d === 'd' && selectedVientiSubject.value.order !== row.order"></div> -->
          </div>
          <div class="icon-container">
            @if (!group.loading) {
              <!-- Vienti is not selected-->
              @if (group.difference === 0 && group.hasVientiOnBothSides && selectedVientiSubject.value?.order !== group.order) {
                <i class="fa fa-chain green-chain"></i>
              }
              @if (!selectedVientiSubject.value && group.hasVientiOnBothSides && !!group.difference && selectedVientiSubject.value?.order !== group.order) {
                <i class="fa fa-chain orange-chain"></i>
              }
              @if (!selectedVientiSubject.value && !group.hasVientiOnBothSides && selectedVientiSubject.value?.order !== group.order) {
                <app-icon-button (click)="autoselectVienti(group, $event)" actionId="Valitse vienti (reskontra)">
                  <i class="fa fa-chain gray-chain"></i>
                </app-icon-button>
              }
              <!-- Vienti IS selected -->
              <!-- And it is on the current renderable group -->
              @if (selectedVientiSubject.value && !selectedVientiSubject.value.a.length && selectedVientiSubject.value.d === 'd' && selectedVientiSubject.value.order === group.order) {
                <i class="blue-arrow fa fa-arrow-right"></i>
              }
              @if (selectedVientiSubject.value && !selectedVientiSubject.value.a.length && selectedVientiSubject.value.d === 'k' && selectedVientiSubject.value.order === group.order) {
                <i class="blue-arrow fa fa-arrow-left"></i>
              }
              @if (selectedVientiSubject.value && selectedVientiSubject.value.a.length > 0 && selectedVientiSubject.value.order === group.order) {
                <app-icon-button mat-icon-button (click)="detach(group, $event)" actionId="Irrota vienti (reskontra)">
                  <i class="fa fa-chain-broken blue-chain" matTooltip="Irroita vienti"></i>
                </app-icon-button>
              }
              <!-- But it is NOT the current renderable group (i.e. it's possible to connect to this row)-->
              @if (selectedVientiSubject.value && group.difference !== 0 && selectedVientiSubject.value.order !== group.order) {
                <app-icon-button (click)="attach(group, $event)" actionId="Yhdistä vienti (reskontra)">
                  <i class="fa fa-chain blue-chain" matTooltip="Yhdistä vienti"></i>
                </app-icon-button>
              }
            } @else {
              <i class="fa fa-spinner spinning"></i>
            }
          </div>
          <div>
            @for (rightCol of group.rightColumnViennit; track rightCol) {
              <div
                app-kirjanpito-reskontra-single-box
                (openKirjaus)="onOpenKirjaus($event)"
                [vienti]="rightCol"
                [toimittaja]="kaikkiToimittajatMap().get(rightCol.ta)"
                [debugUrlStart]="debugUrlStart()"
                [maksutapa]="maksutavatMap().get(rightCol.mt)"
                (setBoxHeight)="(group.leftColumnViennit?.length)"
                [isSelected]="selectedVientiSubject.value?.av === rightCol.av"
                (click)="vientiClicked(rightCol, group.order, $event)"
                [attr.data-vientiavain]="rightCol.av"
              ></div>
            }
            <!-- <div class="empty-outline" style="margin-top: 10px;" *ngIf="selectedVientiSubject.value && selectedVientiSubject.value?.d === 'k' && selectedVientiSubject.value.order !== row.order"></div> -->
          </div>
        </div>
        @if (group.hasVientiOnBothSides) {
          <div class="grid-parent">
            <div class="left-total">
              @if (group.difference < 0) {
                <div class="dark-gray-text">Puuttuu {{ -1 * group.difference | lmoneyl: null : 'fi' }}</div>
              }
            </div>
            <div></div>
            <div class="right-total">
              @if (group.difference > 0) {
                <div class="dark-gray-text">Puuttuu {{ group.difference | lmoneyl: null : 'fi' }}</div>
              }
            </div>
          </div>
        }
      </div>
    }

    <!-- <div *ngIf="selectedVientiSubject.value && selectedVientiSubject.value.a?.length" class="grid-parent resk-group">
  <div class="empty-outline" [style.visibility]="selectedVientiSubject.value?.d === 'd' ? 'visible' : 'hidden'"></div>
  <div></div>
  <div class="empty-outline" [style.visibility]=" selectedVientiSubject.value?.d==='k' ? 'visible' : 'hidden'"></div>
</div> -->

    <div class="acc-total">
      @if (lomake.alkuPvm().value()) {
        <div class="grid-parent">
          <div style="text-align: right">
            @if (alkusaldo >= 0) {
              <span>Alkusaldo: {{ alkusaldo | lmoneyl: null : 'fi' }}</span>
            }
          </div>
          <div></div>
          <div>
            @if (alkusaldo < 0) {
              <span>Alkusaldo: {{ -1 * alkusaldo | lmoneyl: null : 'fi' }}</span>
            }
          </div>
        </div>
      }
      <div class="grid-parent">
        <div style="text-align: right">{{ totalDebit | lmoneyl: null : 'fi' }}</div>
        <div></div>
        <div>{{ totalKredit | lmoneyl: null : 'fi' }}</div>
      </div>
      <div class="grid-parent">
        <div style="text-align: right">
          @if (alkusaldo + totalDebit > totalKredit) {
            <span>Saldo: {{ alkusaldo + totalDebit - totalKredit | lmoneyl: null : 'fi' }}</span>
          }
        </div>
        <div></div>
        <div>
          @if (totalKredit > alkusaldo + totalDebit) {
            <span>Saldo: {{ totalKredit - alkusaldo - totalDebit | lmoneyl: null : 'fi' }}</span>
          }
        </div>
      </div>

      <div lemon-loading [show]="loading()"></div>
    </div>
    <!-- <div class="resk-row">
<div class="left-col" style="text-align: right;">
  Debet
</div>
<div class="right-col">
  Kredit
</div>
</div>

<div *ngFor="let row of renderableReskontraRowsObservable | async" class="resk-row">
  <div class="left-col" *ngIf="row.leftColumnVienti" app-kirjanpito-reskontra-single-box [vienti]="row.leftColumnVienti" [connections]="row.rightColumnViennit?.length ?? 1" [isSelected]="selectedVientiSubject.value?.av === row.leftColumnVienti.av" (click)="vientiClicked(row.leftColumnVienti)"></div>
  <div class="right-col">
    <div *ngFor="let rightCol of row.rightColumnViennit">
      <i *ngIf="row.leftColumnVienti.c" class="fa fa-arrows-h btn conn-icon" (click)="detach(row.leftColumnVienti, rightCol)"></i>
      <i *ngIf="!row.leftColumnVienti.c" class="fa fa-arrow-left btn conn-icon" (click)="attach(row.leftColumnVienti, rightCol)"></i>
      <div app-kirjanpito-reskontra-single-box [vienti]="rightCol" [connections]="0" [isSelected]="selectedVientiSubject.value?.av === rightCol.av" (click)="vientiClicked(rightCol)"></div>
    </div>
    <div class="empty-outline"></div>
  </div>

  <div class="right-col" *ngIf="row.unconnectedRight" app-kirjanpito-reskontra-single-box [vienti]="row.unconnectedRight" [connections]="0" [isSelected]="selectedVientiSubject.value?.av === row.unconnectedRight.av" (click)="vientiClicked(row.unconnectedRight)"></div>
</div> -->
  </form>
</div>
